import React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'

import IconSearch from '@/checkout-instore-legacy/components/Commons/Icons/Search'
import getClassStyle from '@/checkout-instore-legacy/utils/getClassStyle'
import { mediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

export function LoadingResults({
  term,
  abortSearch,
}: {
  term: string
  abortSearch: () => void
}) {
  const tablet = mediaQuery({
    phone: false,
    tablet: true,
    desktop: true,
  })
  const sizeButton = tablet ? 'regular' : 'small'

  return (
    <div className="flex flex-column h-100-ns w-100 vh-50 justify-center tc">
      <div className="center mb5 mb7-ns">
        <IconSearch
          width={tablet ? 100 : 50}
          height={tablet ? 100 : 50}
          color={getClassStyle('c-muted-2', 'color')}
        />
      </div>
      <div className="lh-copy f3-ns ph5 ph7-ns">
        <span className="c-muted-2">
          <FormattedMessage id="searchingFor" />
          <strong>{` ${term}`}</strong>
          <span dangerouslySetInnerHTML={{ __html: '&hellip;' }} />
        </span>
      </div>
      <div className="mt7-ns mt5-s" data-testid="cancel-search-button">
        <Button variation="danger" size={sizeButton} onClick={abortSearch}>
          <FormattedMessage id="cancelSearch" />
        </Button>
      </div>
    </div>
  )
}
